export const colors = {
  primary: '#7785db',
  listCard: '#f2f4ff',
  backgroundForm: '#ffffff',
  transparent: '#00000000',
  black: '#000000'
}
